<section class="mt-3">
  <!-- Subtasks -->
  <p class="text-base font-medium mt-3">Checklist</p>
  <mat-divider role="separator" class="mat-divider mt-1 mat-divider-horizontal" aria-orientation="horizontal">
  </mat-divider>
  <section cdkDropList [cdkDropListData]="task.todos" (cdkDropListDropped)="dropped($event)">
    @for (todo of task.todos; track $index) {
      <div class="flex items-center checklist-item" cdkDrag [cdkDragDisabled]="!canEdit">
        <!-- Read Mode -->
        @if (!todo.editing) {
          <!-- Complete Checkbox -->
          <ts-button
            class="flex-none"
            [icon]="todo.done ? 'check_box' : 'check_box_outline_blank'"
            [type]="'icon'"
            [color]="todo.done ? 'primary' : 'accent'"
            (click)="toggleTodoCompleted(todo)"
            mat-flat-ts-button
            [appAuthorize]="canEdit"
            denyAction="disable"
          ></ts-button>

          <!-- Checklist item title -->
          <p class="flex-1 ml-2">{{ todo.title }}</p>

          <!-- Checklist item actions -->
          <article class="flex-none">
            <ts-button
              class="hidden-btn"
              [icon]="'create'"
              [type]="'icon'"
              [color]="'accent'"
              [matTooltip]="'Edit'"
              (click)="editTodo(todo)"
              mat-flat-ts-button
              [appAuthorize]="canEdit"
              denyAction="disable"
            ></ts-button>
            <ts-button
              class="hidden-btn ml-1"
              [icon]="'delete'"
              [type]="'icon'"
              [color]="'accent'"
              [matTooltip]="'Delete'"
              (click)="deleteTodo(todo)"
              mat-flat-ts-button
              [appAuthorize]="canEdit"
              denyAction="disable"
            ></ts-button>
            @if (task?.todos.length > 1) {
              <ts-button
                cdkDragHandle
                class="ml-1"
                [icon]="'drag_indicator'"
                [type]="'icon'"
                [color]="'accent'"
                [matTooltip]="'Drag'"
              ></ts-button>
            }
          </article>
        }

        <!-- Edit Mode -->
        @if (todo.editing) {
          <mat-form-field [appearance]="'outline'" class="w-full">
            <article class="flex items-center">
              <!-- Edit Mode title -->
              <input matInput [(ngModel)]="todo.title" [ngModelOptions]="{ standalone: true }" />

              <!-- Edit Mode actions -->
              <ts-button
                [icon]="'cancel'"
                [type]="'icon'"
                [color]="'basic'"
                [matTooltip]="'Cancel'"
                mat-flat-ts-button
                [appAuthorize]="canEdit"
                denyAction="disable"
                (click)="cancelTodoEditing(todo)"
              ></ts-button>
              <ts-button
                class="ml-1"
                [icon]="'save'"
                [type]="'icon'"
                [color]="'basic'"
                [matTooltip]="'Save'"
                (click)="saveTodo(todo)"
                mat-flat-ts-button
                [appAuthorize]="canEdit"
                denyAction="disable"
                [disabled]="todo.title.trim().length === 0"
              ></ts-button>
            </article>
          </mat-form-field>
        }
      </div>
    }
  </section>

  <!-- Add Checklist Item Button -->
  <article class="mt-2 xs:hidden">
    <ts-button
      [icon]="'add'"
      [type]="'flat'"
      [color]="'basic'"
      (click)="createTodo()"
      [debounceTime]="200"
      mat-flat-ts-button
      [appAuthorize]="canEdit"
      denyAction="disable"
    >
      Add Checklist Item
    </ts-button>
  </article>
</section>
